/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CalendarBaseService } from '../calendar-base-service';
import { CalendarApiConfiguration } from '../calendar-api-configuration';
import { CalendarStrictHttpResponse } from '../calendar-strict-http-response';

import { diaryAvailibilityPost } from '../fn/diary/diary-availibility-post';
import { DiaryAvailibilityPost$Params } from '../fn/diary/diary-availibility-post';
import { diaryAvailibilitySecurePost } from '../fn/diary/diary-availibility-secure-post';
import { DiaryAvailibilitySecurePost$Params } from '../fn/diary/diary-availibility-secure-post';
import { UrnAvailabilityDayModelAvailibilityModel } from '../models/urn-availability-day-model-availibility-model';

@Injectable({ providedIn: 'root' })
export class CalendarDiaryService extends CalendarBaseService {
  constructor(config: CalendarApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `diaryAvailibilityPost()` */
  static readonly DiaryAvailibilityPostPath = '/Diary/Availibility';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `diaryAvailibilityPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  diaryAvailibilityPost$Response(params?: DiaryAvailibilityPost$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<UrnAvailabilityDayModelAvailibilityModel>> {
    return diaryAvailibilityPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `diaryAvailibilityPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  diaryAvailibilityPost(params?: DiaryAvailibilityPost$Params, context?: HttpContext): Observable<UrnAvailabilityDayModelAvailibilityModel> {
    return this.diaryAvailibilityPost$Response(params, context).pipe(
      map((r: CalendarStrictHttpResponse<UrnAvailabilityDayModelAvailibilityModel>): UrnAvailabilityDayModelAvailibilityModel => r.body)
    );
  }

  /** Path part for operation `diaryAvailibilitySecurePost()` */
  static readonly DiaryAvailibilitySecurePostPath = '/Diary/AvailibilitySecure';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `diaryAvailibilitySecurePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  diaryAvailibilitySecurePost$Response(params?: DiaryAvailibilitySecurePost$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<Array<UrnAvailabilityDayModelAvailibilityModel>>> {
    return diaryAvailibilitySecurePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `diaryAvailibilitySecurePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  diaryAvailibilitySecurePost(params?: DiaryAvailibilitySecurePost$Params, context?: HttpContext): Observable<Array<UrnAvailabilityDayModelAvailibilityModel>> {
    return this.diaryAvailibilitySecurePost$Response(params, context).pipe(
      map((r: CalendarStrictHttpResponse<Array<UrnAvailabilityDayModelAvailibilityModel>>): Array<UrnAvailabilityDayModelAvailibilityModel> => r.body)
    );
  }

}
